import React from "react";
import { useQuery } from "react-query";
import { ListMenu } from "../../common/components/ListMenu";
import { EmployeeListRoutes } from "../Routes";
import { Button, Row, Dropdown } from "antd";
import { PlusOutlined, EditOutlined, DownOutlined } from "@ant-design/icons";
import { useAuth, userActiveView } from "../../utils/Auth";
import {useDebouncedSearch, useQueryWithPagination} from "../../utils/Hooks";
import { AxiosEmployeeAPI } from "../Api";
import { Link } from "react-router-dom";
import { AuthIntegrationApi } from "../Api";
import { AddEmployeeModal } from "./AddEmployeeModal";
import { useSettingValue } from "../../utils/Hooks";
import { ImportCreateEmployeeModal } from "./ImportCreateEmployeeModal";
import { ImportEditEmployeeModal } from "./ImportEditEmployeeModal";

export function EmployeeListLayout() {
  const isNewEmployeeCreationScreenEnabled = useSettingValue(
    "T001_NEW_EMPLOYEE_CREATION_SCREEN_ENABLED",
  );

  const isImportEmployeeScreenEnabled = useSettingValue(
    "T008_EMPLOYEE_IMPORT_SCREEN_ENABLED",
  );

  const { user } = useAuth();
  const [search, debouncedSearch, setSearch] = useDebouncedSearch();
  const activeData = useQueryWithPagination({
    queryKey: ["employee-list-layout", debouncedSearch],
    queryFn: AxiosEmployeeAPI.getAllAccessible,
    search: debouncedSearch,
  });
  const { data: permissions } = useQuery(
    ["permissions", user?.uuid],
    () => AuthIntegrationApi.getPermissions(user?.uuid),
    {
      enabled: !!user?.uuid,
      initialValue: [],
      retry: false,
    },
  );

  const items = [
    {
      label: <ImportCreateEmployeeModal />,
      key: "create",
      icon: <PlusOutlined />,
    },
    {
      label: <ImportEditEmployeeModal />,
      key: "edit",
      icon: <EditOutlined />,
    },
  ];

  return (
    <div>
      <ListMenu search={search} setSearch={setSearch} />
      {userActiveView(user) && (
        <Row justify="end">
          {isNewEmployeeCreationScreenEnabled ? (
            <Link
              to={(location) => ({
                ...location,
                pathname: "/funcionarios/create_employee",
              })}
            >
              <Button type="primary" style={{ marginRight: 20 }}>
                + Adicionar funcionário
              </Button>
            </Link>
          ) : (
            <AddEmployeeModal reload={activeData.refetch} />
          )}
          {isImportEmployeeScreenEnabled && (
            <Dropdown menu={{ items }}>
              <Button type="primary">
                <DownOutlined />
                Importar Funcionários
              </Button>
            </Dropdown>
          )}
        </Row>
      )}
      <EmployeeListRoutes
        search={debouncedSearch}
        activeData={activeData}
        permissions={permissions}
      />
    </div>
  );
}
